import { createFetch } from '@vueuse/core'
import * as Sentry from '@sentry/vue'
export interface ApiError {
  detail: string
  source: {
    pointer: string
  }
  status: number
  title?: string
  code?: string
}

export interface ApiResponseError {
  errors: ApiError[]
}

export const useApi = createFetch({
  baseUrl: `${import.meta.env.VITE_SH_URL}/api/spots/`,
  options: {
    async beforeFetch(ctx) {
      // const authStore = useAuthStore()
      ctx.options.headers = {
        ...ctx.options.headers,
        //Accept: 'application/json',
        //'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded'
        // Authorization: `Bearer ${authStore.token?.id ?? ''}`,
      }

      return ctx
    },
    async onFetchError(ctx) {
      const appStore = useAppStore()

      if (ctx.response && ctx.response.status >= 408) {
        appStore.setIOSError({
          statusCode: ctx.response.status ?? null,
          action: 'showMessage',
          message: 'Please try again later.',
          url: window.location.href,
        })

        Sentry.captureMessage('Web App Show Message Error', {
          level: 'warning',
          extra: {
            statusCode: ctx.response.status,
            message: 'Please try again later.',
            url: window.location.href,
          },
        })

        appStore.sendErrorToiOS()
      }

      return ctx
    },
  },
  fetchOptions: {
    mode: 'cors',
    credentials: 'include',
    cache: 'no-cache',
  },
})
